// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ESHOP_PILLS_ACCESSORIES = "Pr\u00edslu\u0161enstvo";
export const ESHOP_PILLS_CARSEATS = "Autoseda\u010dky";
export const ESHOP_PILLS_STROLLERS = "Ko\u010d\u00edky";
export const HOME_ESHOP_PILLS_MAIN = "Mamaleto E-shop";
